import apiSlice from '../api/api.slice';
import { IBitPublic } from './bit.d';

const bitApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getActiveBits: builder.query<IBitPublic[], void>({
      query: () => ({ url: '/api/v1/bit', method: 'GET' }),
      transformResponse: (response: { bits: IBitPublic[] }) => response.bits,
    }),
  }),
});

export const { useGetActiveBitsQuery } = bitApiSlice;
